import {
  ChartPieIcon,
  PiggyBankIcon,
  RepeatIcon,
  type LucideIcon,
} from "lucide-react";

import { SettlementTreatmentEnum } from "@/__generated__/graphql";

import type { TriageJobEnum } from "./TriageView.keys";

/**
 * How two businesses may settle a payment moved from one to the other - as the
 * server books them (``TransactionsService.settlement_treatments``): what the
 * owner moved, recommended; a loan paid back; and, for money taken in, a
 * dividend - each said of the business the money left and the one it went to.
 * The Move over one payment and Similar's bulk list offer the same.
 */
export const TRIAGE_SETTLEMENTS: {
  treatment: SettlementTreatmentEnum;
  title: string;
  /** Its mark: the owner's money, a loan paid back, a share of the profit. */
  icon: LucideIcon;
  isRecommended: boolean;
  /** Offered only for money taken in. */
  isTakenInOnly: boolean;
  describe: (from: string, to: string) => string;
}[] = [
  {
    treatment: SettlementTreatmentEnum.OwnerEquity,
    title: "Equity",
    icon: PiggyBankIcon,
    isRecommended: true,
    isTakenInOnly: false,
    describe: (from, to) =>
      `Nobody pays it back: the owner moved the money from ${from} to ${to}.`,
  },
  {
    treatment: SettlementTreatmentEnum.Loan,
    title: "Loan",
    icon: RepeatIcon,
    isRecommended: false,
    isTakenInOnly: false,
    describe: (from, to) => `${to} pays ${from} back.`,
  },
  {
    treatment: SettlementTreatmentEnum.Dividend,
    title: "Dividend",
    icon: ChartPieIcon,
    isRecommended: false,
    isTakenInOnly: true,
    describe: (from, to) =>
      `Nobody pays it back: ${from} paid ${to} a share of its profit.`,
  },
];

/** What each kind of way to book a payment is called, said of how many are offered on its row's booking chip's hover. */
export const TRIAGE_RECOMMENDATION_NOUNS: Record<TriageJobEnum, string> = {
  CATEGORIZE: "posting",
  MATCH_DOCUMENT: "match",
  DUPLICATE: "duplicate",
  SPLIT: "split",
  TRANSFER: "transfer",
  PAIR: "pair",
};
